(() => {
  const guardName = "__andskyCartCountSyncV1";
  if (window[guardName]) return;
  window[guardName] = true;

  const root = () => window.Shopify?.routes?.root || "/";
  const cartUrl = () => `${root()}cart.js`.replace(/([^:]\/)\/+/g, "$1");

  const updateCount = (count) => {
    document.querySelectorAll("cart-count, [data-cart-count], .cart-count").forEach((node) => {
      node.textContent = count;
      node.hidden = count < 1;
      node.setAttribute("aria-label", `${count} item${count === 1 ? "" : "s"} in cart`);
    });
  };

  const sync = async () => {
    try {
      const response = await fetch(cartUrl(), {
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (typeof cart.item_count === "number") updateCount(cart.item_count);
    } catch (error) {
      // Keep the page interactive if the cart endpoint is temporarily unavailable.
    }
  };

  document.addEventListener("DOMContentLoaded", sync);
  window.addEventListener("pageshow", sync);
  document.addEventListener("cart:updated", (event) => {
    const count = event.detail?.cart?.item_count;
    if (typeof count === "number") updateCount(count);
    else sync();
  });

  window.AndskyCartCountSync = { updateCount, sync };
})();
